import { createSlice } from '@reduxjs/toolkit';
import { SortDirection } from 'common/constant';
import i18n from 'i18n/i18n';

type notificationState = {
  loading: boolean;
  filterSearchTotal: number;
  filterInitialSearchData: [];
  filterSearchData: any[];
  isMdkNotification: boolean;
  detailNotification: any;
  showSearchModal: boolean;
  message: string;
  success: boolean;
  checkedNotifications: number[];
  showSortModal: boolean;
  sortDirection: string;
  sortSelected: {
    name: string;
    value: string;
  } | null;
};

const initialState: notificationState = {
  loading: false,
  filterSearchTotal: 0,
  filterInitialSearchData: [],
  filterSearchData: [],
  isMdkNotification: false,
  detailNotification: null,
  showSearchModal: true,
  message: '',
  success: false,
  checkedNotifications: [],
  showSortModal: false,
  sortDirection: '',
  sortSelected: null,
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    searchNotification: (state, action) => {
      state.loading = true;
      state.message = '';
    },
    searchNotificationSuccess: (state, action) => {
      state.loading = false;
      state.filterInitialSearchData = action.payload.records;
      state.filterSearchData = action.payload.records;
      state.filterSearchTotal = action.payload.total;
      state.showSearchModal = false;
      if (!state.filterSearchTotal) {
        state.message = i18n.t('message.common.0001');
      }
      state.success = false;
    },
    searchNotificationFailure: (state) => {
      state.loading = false;
    },
    updateKdkFlg: (state, action) => {
      state.loading = true;
      state.message = '';
    },
    updateKdkFlgSuccess: (state, action) => {
      state.loading = false;
    },
    updateKdkFlgFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    updateKdkFlgDetail: (state, action) => {
      state.message = '';
    },
    updateKdkFlgDetailSuccess: (state, action) => {
      state.message = '';
    },
    updateKdkFlgDetailFailure: (state, action) => {
      state.message = action.payload?.message;
    },
    updateKdkFlgDetails: (state, action) => {
      state.message = '';
    },
    updateKdkFlgDetailsSuccess: (state, action) => {
      state.message = '';
    },
    updateKdkFlgDetailsFailure: (state, action) => {
      state.message = action.payload?.message;
    },
    isMdkNotification: (state, action) => {
      state.message = '';
    },
    isMdkNotificationSuccess: (state, action) => {
      state.isMdkNotification = action.payload.total !== 0;
    },
    isMdkNotificationFailure: (state, action) => {
      state.message = action.payload?.message;
    },
    detailNotification: (state, action) => {
      state.loading = true;
      state.message = '';
    },
    detailNotificationSuccess: (state, action) => {
      state.loading = false;
      state.detailNotification = action.payload;
    },
    detailNotificationFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    updateNotification: (state, action) => {
      state.loading = true;
      state.message = '';
    },
    updateNotificationSuccess: (state, action) => {
      state.loading = false;
    },
    updateNotificationFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    cleanData: (state) => {
      return {
        ...initialState,
        isMdkNotification: state.isMdkNotification,
      };
    },
    toggleSearchModal: (state) => {
      state.showSearchModal = !state.showSearchModal;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action.payload;
    },
    toggleSortModal: (state) => {
      if (!state.showSortModal) {
        state.showSearchModal = false;
      }
      state.showSortModal = !state.showSortModal;
    },
    setSortSelected: (state, action) => {
      state.sortSelected = action.payload;
      if (action.payload) {
        state.sortDirection = SortDirection.ASC;
      }
      if (!state.filterSearchData.length) {
        state.showSortModal = false;
        state.showSearchModal = true;
      }
    },
    setCheckedNotifications: (state, action) => {
      const notificationId = action.payload;
      if (state.checkedNotifications.includes(notificationId)) {
        state.checkedNotifications = state.checkedNotifications.filter(
          (checkedNotification) => checkedNotification !== notificationId
        );
      } else {
        state.checkedNotifications = [...state.checkedNotifications, notificationId];
      }
    },
  },
});

export const {
  searchNotification,
  searchNotificationSuccess,
  searchNotificationFailure,
  updateKdkFlg,
  updateKdkFlgSuccess,
  updateKdkFlgFailure,
  updateKdkFlgDetail,
  updateKdkFlgDetailSuccess,
  updateKdkFlgDetailFailure,
  updateKdkFlgDetails,
  updateKdkFlgDetailsSuccess,
  updateKdkFlgDetailsFailure,
  isMdkNotification,
  isMdkNotificationSuccess,
  isMdkNotificationFailure,
  detailNotification,
  detailNotificationSuccess,
  detailNotificationFailure,
  updateNotification,
  updateNotificationSuccess,
  updateNotificationFailure,
  cleanData,
  toggleSearchModal,
  setLoading,
  setSortDirection,
  toggleSortModal,
  setSortSelected,
  setCheckedNotifications,
} = notificationSlice.actions;

export default notificationSlice.reducer;
